import { Typography } from "@material-ui/core"
import styled from "styled-components"

const StyledHeading = styled(Typography).attrs({
  component: "h2",
  variant: "h4",
})<{ $small?: boolean; $textIndent?: boolean; $marginBottom?: number }>`
  text-align: right;
  line-height: 1;
  font-family: "NarkisBlock";
  ${(p) => p?.$small && "font-size: 24px;"}
  ${(p) => p?.$textIndent && "margin-right: 150px;"}
  ${(p) => p?.$marginBottom && `margin-bottom: ${p.$marginBottom}px;`}
  ${(p) => p.theme.breakpoints.down("sm")} {
    margin-right: 0;
  }
`

type HeadingTextProps = {
  text: string
  tabIndex?: number
  small?: boolean
  textIndent?: boolean
  marginBottom?: number
}

const HeadingText = ({
  text,
  tabIndex,
  small,
  textIndent,
  marginBottom,
}: HeadingTextProps) => {
  return (
    <StyledHeading
      tabIndex={tabIndex}
      $small={small}
      $textIndent={textIndent}
      $marginBottom={marginBottom}
    >
      {text}
    </StyledHeading>
  )
}

export default HeadingText
